import { api } from "../lib/axios"

export async function CasesHomeFn() {
  const response = await api.get('casesHome')

  return response.data
}